type TTLWrapper = {
    value: string
    expiresAt: number
}

const isTTLWrapper = (data: unknown): data is TTLWrapper => {
    return typeof data === 'object' && data !== null && 'value' in data && 'expiresAt' in data
}

export const setItemWithTTL = (key: string, value: string, ttlMs: number) => {
    if (import.meta.server) return
    const wrapper: TTLWrapper = {
        value,
        expiresAt: Date.now() + ttlMs
    }
    try {
        localStorage.setItem(key, JSON.stringify(wrapper))
    } catch (e) {
        console.error('[storageWithTTL] Failed to set item', e)
    }
}

export const getItemWithTTL = (key: string, defaultTtlMs: number): string | null => {
    if (import.meta.server) return null
    const raw = localStorage.getItem(key)
    if (!raw) return null

    try {
        const parsed = JSON.parse(raw)
        if (isTTLWrapper(parsed)) {
            if (Date.now() > parsed.expiresAt) {
                localStorage.removeItem(key)
                return null
            }
            return parsed.value
        }
    } catch {
        // Fallthrough for legacy raw string values
    }

    // It's a legacy string (or JSON that wasn't a TTL wrapper)
    setItemWithTTL(key, raw, defaultTtlMs)
    return raw
}

export const sweepExpiredItems = (prefixes: string[]) => {
    if (import.meta.server) return
    const keysToRemove: string[] = []
    
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i)
        if (!key) continue
        
        if (prefixes.some(prefix => key.startsWith(prefix))) {
            const raw = localStorage.getItem(key)
            if (!raw) continue
            try {
                const parsed = JSON.parse(raw)
                if (isTTLWrapper(parsed)) {
                    if (Date.now() > parsed.expiresAt) {
                        keysToRemove.push(key)
                    }
                }
            } catch {
                // Ignore raw strings during sweep. They will be upgraded 
                // the next time getItemWithTTL is called for that specific key.
            }
        }
    }
    
    for (const key of keysToRemove) {
        localStorage.removeItem(key)
    }
}
